import { PaymentAmount } from 'guest-data-types-ts-lib';

export type Count = { count: number; min?: number; max?: number; name: string };

export enum OccupancyKeys {
    ADULTS = 'adults',
    CHILDREN = 'children',
    PETS = 'pets',
}

export type OccupancyCounts = { [key in OccupancyKeys]: Count };

export type OccupancyCost = {
    total: PaymentAmount;
    convertedTotal?: PaymentAmount;
    adjustment?: PaymentAmount;
    previousBalance?: PaymentAmount;
};
